var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customer-expected-count"},[(!_vm.loaded)?_c('Icon',{staticClass:"spin",attrs:{"type":"ios-loading","size":"12"}}):_c('span',{staticClass:"customer-count"},[_vm._v(" "+_vm._s(_vm.total)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }